import React from 'react';
import { Link } from 'react-router-dom';
export function Hero() {
  return <section className="relative bg-gradient-to-b from-blue-900 via-blue-800 to-blue-700 text-white overflow-hidden" data-id="element-174">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-20" style={{
      backgroundImage: `url('https://images.unsplash.com/photo-1449824913935-59a10b8d2000?w=1920&q=80')`,
      backgroundSize: 'cover',
      backgroundPosition: 'center bottom'
    }} data-id="element-175" />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-24" data-id="element-176">
        <div className="text-center" data-id="element-177">
          <h1 className="text-3xl md:text-5xl font-bold mb-4" data-id="element-178">
            Where Nakuru Creatives Meet Buyers
          </h1>
          <p className="text-lg md:text-xl text-blue-100 mb-8 max-w-2xl mx-auto" data-id="element-179">
            Discover goods, services, events, and connect with creatives.
          </p>

          <div className="flex flex-wrap justify-center gap-3" data-id="element-180">
            <Link to="/goods" className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-md font-medium transition-colors" data-id="element-181">
              Explore Goods
            </Link>
            <Link to="/services" className="bg-red-600 hover:bg-red-700 text-white px-6 py-3 rounded-md font-medium transition-colors" data-id="element-182">
              Explore Services
            </Link>
            <Link to="/events" className="bg-blue-500 hover:bg-blue-600 text-white px-6 py-3 rounded-md font-medium transition-colors" data-id="element-183">
              Explore Events
            </Link>
            <Link to="/signup" className="bg-orange-500 hover:bg-orange-600 text-white px-6 py-3 rounded-md font-medium transition-colors" data-id="element-184">
              Sign Up / Login
            </Link>
          </div>
        </div>
      </div>

      {/* City Skyline Effect */}
      <div className="absolute bottom-0 left-0 right-0 h-16 bg-gradient-to-t from-gray-100 to-transparent" data-id="element-185" />
    </section>;
}